module.exports = __webpack_public_path__ + "static/item_template_default-2d057d792ee7ee89142a369233a7b82b.png";